import {initElements} from './elements';
import {initComponents} from './components';
// import {initHash} from './hash';

export const initApp = () => {
	initElements();
	initComponents();
	// initHash();
};
